import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { type Root, createRoot } from 'react-dom/client'
import App from './App'
import './styles/reset.css'
import './index.css'
import { ToastContainer } from 'react-toastify'

declare global {
  interface HTMLElement {
    _reactRoot?: Root
  }
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (previously cacheTime)
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

const rootElement = document.getElementById('root')
if (rootElement) {
  if (!rootElement._reactRoot) {
    rootElement._reactRoot = createRoot(rootElement)
  }

  rootElement._reactRoot.render(
    <QueryClientProvider client={queryClient}>
      <App />
      <ReactQueryDevtools initialIsOpen={false} />
      <ToastContainer position="top-center" />
    </QueryClientProvider>,
  )
} else {
  console.error('Root element not found')
}
